<ng-template #modalContent let-modal>
  <div class="modal-header">
    <h4 class="modal-title" id="modal-basic-title">{{title}}</h4>
    <button type="button" class="btn-close" (click)="dismiss()"></button>
  </div>
  <div class="modal-body">
    <div [innerHTML]="body"></div>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-outline-secondary" (click)="dismiss()">
      {{ "Common.btn_cancel" | translate }}
    </button>

    @for (button of buttons; track button) {
      <button type="button" class="btn" [class]="'btn-' + button.color" (click)="close(button.index)">
        {{button.text}}
      </button>
    }
  </div>
</ng-template>
